export default `@media (min-width: 320px) {
  :host(.last) {
    flex: 0;
  }
}
@media (min-width: 927px) {
  :host(.last) {
    flex: 1;
  }
}

:host {
  display: flex;
  flex: 1;
  position: relative;
}
:host ::slotted(ids-text) {
  color: var(--ids-process-indicator-step-color-default);
}
@media (max-width: 927px) {
  :host .ids-process-indicator-step .line {
    transform: var(--ids-process-indicator-line-transform-mobile);
  }
  :host .label {
    display: none;
  }
  :host .details {
    display: none;
  }
  :host .step {
    margin-top: var(--ids-process-indicator-step-margin-top);
  }
}
@media (min-width: 927px) {
  :host .details {
    display: unset;
  }
  :host .label {
    display: unset;
  }
  :host .step {
    margin-top: unset;
  }
}
@media (min-width: 928px) {
  :host .label {
    display: flex;
  }
}

::slotted(*) {
  display: block;
  margin: var(--ids-process-indicator-margin);
}

.ids-process-indicator-step ids-text::part(text) {
  color: var(--ids-color-foreground-default-default);
  margin: var(--ids-process-indicator-text-margin);
}
.ids-process-indicator-step ids-text.label {
  margin: var(--ids-process-indicator-margin);
  margin-bottom: var(--ids-space-sm);
  white-space: nowrap;
}
.ids-process-indicator-step .line {
  position: absolute;
  transform: var(--ids-process-indicator-line-transform);
  height: var(--ids-process-indicator-font-line-height);
  width: 100%;
  background-color: var(--ids-color-border-strong);
}
.ids-process-indicator-step .step {
  display: flex;
  transform: var(--ids-process-indicator-step-transform);
  height: var(--ids-process-indicator-step-height);
  width: var(--ids-process-indicator-step-width);
  border-radius: var(--ids-process-indicator-border-radius-step);
  background-color: var(--ids-process-indicator-color-background);
  border: 2px solid var(--ids-color-border-strong);
}

:host([status=cancelled]) .step {
  background-color: var(--ids-process-indicator-canceled-step-color-background);
  width: 16px;
  height: 16px;
  border: 0;
  justify-content: center;
}
:host([status=cancelled]) .step ids-icon {
  display: flex;
  justify-content: center;
  color: var(--ids-process-indicator-canceled-step-color-icon);
}

:host([status=done]) .step {
  border: var(--ids-process-indicator-border-done);
  background-color: var(--ids-process-indicator-color-primary);
}

:host([status=started]) .step {
  border: var(--ids-process-indicator-border-started);
  background-color: var(--ids-process-indicator-color-background);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
